import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pnfabwsu5v: FaireBrandEntity = {
  token: "b_pnfabwsu5v",
  type: "brand",
  name: "Glam Bar Bazaar",
  avatarUrl:
    "https://cdn.faire.com/fastly/1f169ae95cae25d3a009ef95e6a8bad914211765d2f6d549af7537762e7bbc2e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e18a35a4e63d3f0d2d2e54b0c1bbf08c319caa5e1304557b359e94b2fec39d98.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1f169ae95cae25d3a009ef95e6a8bad914211765d2f6d549af7537762e7bbc2e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e18a35a4e63d3f0d2d2e54b0c1bbf08c319caa5e1304557b359e94b2fec39d98.jpeg",
  location: "Winnipeg, MB, CAN",
  minimumOrderDollars: 187,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Glam Bar Bazaar is a Canadian jewellery brand that originated in the heart of Winnipeg, Manitoba 3 years ago. It started in a home with a love for hand crafted jewelry which has now sprung into 5 physical locations across Canada. They are Canada's hub for permanent jewelry and affordable luxury. Get first dibs on our exclusive permanent jewelry chains & charms.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:41.571Z",
    importedBy: "entity-db-cli",
  },
};
